<template>
<div :class="channel === 'pop'?'NewcomerSignInPop':'NewcomerSignIn'">
  <div class="bannerBox">
    <div class="back" @click="back()" v-if="channel === 'page'">
      <img src="../../assets/images/NewcomerSignIn/backIcon.png" alt="" class="backIcon">
      <div class="backText">{{$t('lang.NewcomerSignIn.noviceTask')}}</div>
    </div>
    <div class="bannerTextBox">
      <div class="title">{{$t('lang.NewcomerSignIn.title')}}</div>
      <div class="timeBox">
        <div class="time" v-if="remainingTime">
          <div class="timeItem">
            <div class="value">{{ remainingTime.h }}</div>
            <div class="label">{{$t('lang.NewcomerSignIn.hour')}}</div>
          </div>
          <div class="b">：</div>
          <div class="timeItem">
            <div class="value">{{remainingTime.m}}</div>
            <div class="label">{{$t('lang.NewcomerSignIn.min')}}</div>
          </div>
          <div class="b">：</div>
          <div class="timeItem">
            <div class="value">{{remainingTime.s}}</div>
            <div class="label">{{$t('lang.NewcomerSignIn.sec')}}</div>
          </div>
        </div>
      </div>
    </div>
    <img v-if="channel === 'pop'" src="../../assets/images/NewcomerSignIn/banner.png" alt="" class="banner">
    <img v-else src="../../assets/images/NewcomerSignIn/banner-page.png" alt="" class="banner-page">
  </div>
  <div class="checkInBox">
    <div class="row1">
      <div class="checkInTitle">{{$t('lang.NewcomerSignIn.checkInTitle')}}</div>
      <div class="ruleslabel" @click="rulePop = true">{{$t('lang.NewcomerSignIn.rules')}}</div>
    </div>
    <div class="row2" v-if="replaceGet($t('lang.NewcomerSignIn.getTips'))">
      {{replaceGet($t('lang.NewcomerSignIn.getTips'))}}
    </div>
    <div class="row3">
      <div class="checkInItemBox" v-for="(item, index) in checkInList" :key="index" v-if="checkInList.length!==0">
        <div class="checkInCardBox">
          <div class="items">
            <img v-if="item.Type === '1'" :src="VIPIcon" alt="" class="icon1">
            <img v-if="item.Type === '2'" :src="bonusIcon" alt="" class="icon2">
            <img v-if="item.Type === '4'" :src="calendarIcon" alt="" class="icon3">
            <img v-if="item.Type === '3'" :src="voucher" alt="" class="icon4">
            <div :class="item.Type=== '1' || item.Type=== 'voucher' ? 'vipLabel':'bonusLabel'" v-if="item.Value != 0">
              <span v-if="item.Type === '1'">VIP</span>
              <span v-if="item.Type === '2'">+₹</span>
              <span v-if="item.Type === '3'">Deposit+</span>{{item.Value}}<span v-if="item.Type === '3'">%</span>
            </div>
          </div>
          <div class="DoneMask" v-if="item.Status === 1">
            <img src="../../assets/images/NewcomerSignIn/finished.png" alt="" class="finished">
          </div>
        </div>
        <div class="available" v-if="item.Status === 0" />
      </div>
    </div>
    <div class="checkInBtnBox">
      <div class="checkInBtn" v-if="EndTime && getIsHaveCheckeIn() && taskList.length !==0" @click="claimTask()">{{$t('lang.NewcomerSignIn.checkIn')}}</div>
      <div class="checkInBtnNo" v-else>{{$t('lang.NewcomerSignIn.checkIn')}}</div>
    </div>

  </div>
  <div class="taskDoneBox">
    <div class="taskDoneCard">
      <div class="title">{{$t('lang.NewcomerSignIn.TasksDoneBigRewards')}}</div>
      <div class="contentList">
        <div class="taskItem" v-for="(item, index) in taskList" :key="index">
          <div class="taskInfo">
            <div class="taskIcon">
              <img :src="bonusIcon" alt="" class="icon">
              <div class="label">₹{{item.Reward}}</div>
            </div>
            <div class="label">{{ $t('lang.taskSign.' + item.TaskName).replace('{Amount}', item.TaskAchieveValue) }}</div>
          </div>
          <div v-if="item.Status === 0" @click="claimTask(item)" class="tasBtn">{{$t('lang.NewcomerSignIn.claim')}}</div>
          <div v-if="item.Status === 1" class="tasBtnDone" @click="goDoTask(item.TaskName)">{{$t('lang.NewcomerSignIn.done')}}</div>
          <div v-if="item.Status === -2" class="tasBtnGo" @click="goDoTask(item.TaskName)">{{$t('lang.NewcomerSignIn.go')}}</div>
        </div>
      </div>
    </div>
  </div>
    <div class="ruleMask" v-if="rulePop">
      <div class="ruleBox">
        <img @click="rulePop = false" src="../../assets/images/account/close.png" alt="" class="closeRulePopBtn">
        <div class="title">{{$t('lang.NewcomerSignIn.rules')}}</div>
        <div class="content" v-html="formatterRules(rules)"></div>
      </div>
    </div>
  <div class="confirmMask" v-if="confirmMarsk">
    <div class="confirmBox">
<!--      <img @click="confirmMarsk = false" src="../../assets/images/account/close.png" alt="" class="closeRulePopBtn">-->
      <div class="title">{{$t('lang.NewcomerSignIn.congratulations')}}</div>
      <div class="content">
        <div>
          <span class="VIP" v-if="nowCheckIn.Type === '1'">{{replaceGetCheckIn($t('lang.NewcomerSignIn.VIP'))}}</span>
          <span class="coinVal" v-else-if="nowCheckIn.Type === '2'">{{replaceGetCheckIn($t('lang.NewcomerSignIn.coin'))}}</span>
          <span class="scale" v-else-if="nowCheckIn.Type === '3'">{{replaceGetCheckIn($t('lang.NewcomerSignIn.scale'))}}</span>
          <span class="scale" v-else>{{$t('lang.NewcomerSignIn.successfully')}}</span>
        </div>
       <div class="checkTheVIPPrivileges" @click="goVIP()" v-if="nowCheckIn.Type === '1'">
         {{$t('lang.NewcomerSignIn.VIPPrivileges')}}
       </div>
      </div>
      <div class="claimBtn" @click="confirmMarsk = false">{{$t('lang.NewcomerSignIn.claim')}}</div>
    </div>
  </div>
</div>
</template>

<script>
import VIPIcon from '../../assets/images/NewcomerSignIn/VIPIcon.png'
import bonusIcon from '../../assets/images/NewcomerSignIn/bonusIcon.png'
import calendarIcon from '../../assets/images/NewcomerSignIn/calendarIcon.png'
import voucher from '../../assets/images/NewcomerSignIn/voucher.png'
import store from '@/store/store'
import request from '@/service'
import {LogUtils} from '@/utils'
import {Toast} from 'mint-ui'
export default {
  name: 'index',
  props: ['channel', 'VersionCData', 'isClose'],
  data () {
    return {
      VIPIcon,
      bonusIcon,
      calendarIcon,
      voucher,
      nowCheckIn: {
        Day: -1,
        Type: -1,
        Status: -1,
        Value: -1
      },
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      EndTime: null,
      remainingTime: null,
      startTime: null,
      confirmMarsk: false,
      rulePop: false,
      rules: '' +
        '1. Event time: October 27-November 3.\n' +
        '          2. The top 10 players in daily deposit/bet amount can enter the daily TOP10 ranking list and receive corresponding ranking rewards.\n' +
        '          3. Players whose daily deposit/bet amount reaches the specified amount and who are not in the TOP10 can receive the target reward.\n' +
        '          4. Daily ranking rewards and daily target rewards cannot be obtained at the same time.\n' +
        '          5. Daily rewards need to be available after 0:00 the next day.\n' +
        '          6. Any player who uses cheating, false registration of accounts, or other fraudulent behaviors will have their deposits confiscated and their accounts banned.\n' +
        '          7. PGEbet has the final right of interpretation for this event.',
      checkInList: [],
      taskList: [],
      lang: localStorage.getItem('locale')
    }
  },
  beforeDestroy () {
    clearInterval(this.startTime)
    this.startTime = null
  },
  watch: {
    '$store.state.locale': function (val) {
      if (val) {
        this.lang = val
        this.getRules()
      }
    },
    isClose (val) {
      if (val) {
        clearInterval(this.startTime)
        this.startTime = null
      }
    }
  },
  created () {
    if (!this.userInfo) {
      this.$router.push('Login')
    }
    this.getRules()
    if (this.userInfo) {
      this.getUserGiftCollectInfo()
    }
  },
  methods: {
    goVIP () {
      this.$emit('close')
      this.$router.push('vip')
    },
    collectGift (Id) {
      let url = '/innovation/sevendaygift/collect-gift'
      let data = {
        CollectId: Id || null,
        UserId: this.userInfo.UserId,
        SevenDayGiftModel: 'versionC'
      }
      request('post', url, data, false).then(res => {
        if (res) {
          this.getUserGiftCollectInfo(1)
          if (!Id) {
            this.confirmMarsk = true
          }
        }
      })
    },
    getRules () {
      const url = `/innovation/activity/get/rule?Name=SevenDayGiftVersionCRule`
      request('get', url).then(res => {
        if (this.lang === 'IN') {
          this.rules = res.Hindi.RuleText
        } else {
          this.rules = res.English.RuleText
        }
      })
    },
    getRemainingTime (endTimeStr) {
      // 解析结束时间
      const [datePart, timePart] = endTimeStr.split(' ')
      const [year, month, day] = datePart.split('-').map(Number)
      const [hours, minutes, seconds] = timePart.split(':').map(Number)
      const endTime = new Date(year, month - 1, day, hours, minutes, seconds)
      const now = new Date()
      const diff = endTime - now

      if (diff <= 0) {
        this.remainingTime = null
      }

      const totalSeconds = Math.floor(diff / 1000)
      const h = Math.floor(totalSeconds / 3600)
      const remainingSeconds = totalSeconds % 3600
      const m = Math.floor(remainingSeconds / 60)
      const s = remainingSeconds % 60

      // 补零函数
      const pad = (num) => num.toString().padStart(2, '0')
      this.remainingTime = {
        h: pad(h),
        m: pad(m),
        s: pad(s)
      }
    },
    getUserGiftCollectInfo (isclaim) {
      store.commit('setGiftLoadingInfoStatus', true)
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if (userInfo) {
        const url = '/innovation/sevendaygift/get-user-info'
        const data = {
          userId: userInfo.UserId
        }
        store.commit('setGiftLoadingInfoStatus', true)
        request('post', url, data, true).then(res => {
          if (res && res.SevenDayGiftModel && res.SevenDayGiftModel === 'versionC') {
            if (isclaim && res.VersionCRewardList && res.VersionCRewardList.length !== 0 && res.VersionCWaitClaimTasks && res.VersionCWaitClaimTasks.length !== 0) {
              let GiftShowRedCircle = false
              res.VersionCRewardList.forEach(item => {
                if (item.Status === 0) {
                  store.commit('setGiftShowRedCircle', true)
                }
              })
              res.VersionCWaitClaimTasks.forEach(item => {
                if (item.Status === 0) {
                  store.commit('setGiftShowRedCircle', true)
                }
              })
              store.commit('setGiftShowRedCircle', GiftShowRedCircle)
            }
            this.taskList = res.VersionCWaitClaimTasks
            if (res.VersionCDoneTasks.length !== 0) {
              res.VersionCDoneTasks.forEach(item => {
                this.taskList.push(item)
              })
            }
            this.checkInList = res.VersionCRewardList
            this.EndTime = res.EndTime
            if (this.EndTime) {
              this.startTime = setInterval(() => {
                this.getRemainingTime(this.EndTime)
                if (!this.remainingTime) {
                  clearInterval(this.startTime)
                }
              })
            }
          }
          let IsShowIcon = false
          if (res.IsShowIcon) {
            IsShowIcon = true
          }
          store.commit('setShowGiftIcon', IsShowIcon)
        }).catch(err => {
          console.log(err)
          store.commit('setGiftLoadingInfoStatus', false)
        })
      } else {
        store.commit('setHideGiftPop', true)
        store.commit('setGiftLoadingInfoStatus', false)
      }
    },
    replaceGetCheckIn (val) {
      if (this.nowCheckIn && this.nowCheckIn.Type === '1') {
        return val.replace('{VIP}', this.nowCheckIn.Value)
      } else if (this.nowCheckIn && this.nowCheckIn.Type === '2') {
        return val.replace('{coin}', this.nowCheckIn.Value)
      } else if (this.nowCheckIn && this.nowCheckIn.Type === '3') {
        return val.replace('{scale}', this.nowCheckIn.Value)
      } else {
        return val
      }
    },
    replaceGet (val) {
      // eslint-disable-next-line no-unused-vars
      let getGift
      if (this.checkInList.length !== 0) {
        try {
          this.checkInList.forEach((item, index) => {
            if (item.Status === -2) {
              getGift = item
              throw new Error('BreakException')
            }
          })
        } catch (e) {}
        if (getGift && getGift.Type === '1') {
          return val.replace('{reward}', 'VIP' + getGift.Value)
        } else if (getGift && getGift.Type === '2') {
          return val.replace('{reward}', '₹' + getGift.Value)
        } else if (getGift && getGift.Type === '3') {
          return val.replace('{reward}', 'Deposit+' + getGift.Value)
        } else {
          return null
        }
      }
    },
    formatterRules (rules) {
      return rules.replace(/\n/g, '<br>')
    },
    goDoTask (taskName) {
      switch (taskName) {
        case 'login':
          // this.$emit('close')
          Toast(this.$t('lang.NewcomerSignIn.LogInTsakTip'))
          break
        case 'download_app':
          this.downloadApp()
          break
        case 'deposit':
          this.$router.push('Deposit')
          this.$emit('close')
          break
        case 'withdrawal':
          this.$router.push('Withdraw')
          this.$emit('close')
          break
        case 'add_bank_account':
          this.$router.push('createBankAccount')
          this.$emit('close')
          break
        case 'share':
          this.$router.push('Earn')
          this.$emit('close')
          break
        case 'click_share':
          this.$router.push('Earn')
          this.$emit('close')
          break
        case 'upi_deposit_amount':
          this.$router.push('Deposit')
          this.$emit('close')
          break
        case 'complete_user_information':
          this.$router.push('Edit')
          this.$emit('close')
          break
        case 'complete_user_information_email':
          this.$router.push('Edit')
          this.$emit('close')
          break
        case 'bet':
          if (this.channel === 'pop') {
            this.$emit('close')
          } else {
            this.$router.push('Home')
          }
          break
        default:
          break
      }
    },
    getIsHaveCheckeIn () {
      let isHaveCheckIn = false
      this.checkInList.forEach(item => {
        if (item.Status === 0) {
          isHaveCheckIn = true
        }
      })
      return isHaveCheckIn
    },
    claimTask (item) {
      if (!item || !item.Id) {
        // eslint-disable-next-line
        // no-unused-vars
        let isHaveCheckIn = false
        this.checkInList.forEach(item => {
          if (item.Status === 0) {
            this.nowCheckIn = item
            isHaveCheckIn = true
          }
        })
        if (isHaveCheckIn) {
          this.collectGift()
        }
      } else {
        this.collectGift(item.Id)
      }
    },
    downloadApp () {
      LogUtils.downloadApp('ClickTopDown')
    },
    back () {
      clearInterval(this.startTime)
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes openBox {
  0% {
    transform: scale(0);
    opacity: 0; /* 开始时完全透明 */
  }
  50% {
    transform: scale(1.1); /* 在中间稍微放大一点，增加视觉冲击 */
    opacity: 1; /* 在中间变为完全不透明 */
  }
  100% {
    transform: scale(1); /* 结束时恢复到正常大小 */
    opacity: 1; /* 保持完全不透明 */
  }
}
.NewcomerSignInPop{
  height: 100%;
  width: 100%;
  /* 整个滚动条 */
  ::-webkit-scrollbar {
    width: 0.852vw; /* 设置滚动条宽度 */
    border-radius: 0px; /* 设置滚动条圆角 */
    margin-left: 2vw;
  }
  .bannerBox{
    width: 100%;
    height: 29.619vw;
    position: relative;
    display: flex;
    flex-direction: column;
    .banner{
      height: 100%;
      width: 100%;
    }
    .bannerTextBox{
      position: absolute;
      left: 5%;
      top: 21%;
      display: flex;
      flex-direction: column;
      gap: 0vw;
      .title{
        color: #FFFFFF;
        font-size: 4.5833vw;
        font-weight: 700;
      }
      .timeBox{
        display: flex;
        justify-content: center;
        flex-direction: column;
        //border: 1px solid red;
        .b{
          color: #FFF59D;
          font-weight: 700;
          font-size: 7.5vw;
          padding-left: 2.5vw;
          margin-top: -4vw;
        }
        .time{
          display: flex;
          align-items: center;
          margin-top: 1vw;
          .timeItem{
            display: flex;
            flex-direction: column;
            align-items: center;
            .value{
              color: #FFF59D;
              font-weight: 700;
              font-size: 7.5vw;

            }
            .label{
                color: #636363;
              font-weight: 700;
              font-size: 2.777vw;
            }
          }
        }
      }
    }
  }
  .checkInBox{
    display: flex;
    flex-direction: column;
    padding: 3.697vw;
    .row1{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 2.9vw;
      .checkInTitle{
        font-size: 4.444vw;
        color: #fff;
        font-weight: 700;
      }
      .ruleslabel{
        font-size: 3.277vw;
        color: #4897FF;
        text-decoration: underline;
        text-decoration-color: #4897FF;
        text-underline-offset: 4px;
      }
    }
    .row2{
      padding-bottom: 2.9vw;
      font-size: 3.055vw;
      color: #6F6F6F;
    }
    .row3{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 4.441vw;
      .checkInItemBox{
        position: relative;
        .checkInCardBox{
          width: 10.238vw;
          height: 13.652vw;
          background: #F5F5F5;
          box-shadow: inset 0px 0px 1.6px rgba(0, 0, 0, 0.8);
          border-radius: 0.833vw;
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 5.5vw;
          .items{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 0.5vw;
            .vipLabel{
              color: #007591;
              font-size: 2.8vw;
              font-weight: 700;
              text-align: center;
              white-space: normal;
              word-break: break-word;
            }
            .bonusLabel{
              width: 11vw;
              color: #BD6200;
              font-size: 2.8vw;
              font-weight: 700;
              text-align: center;
              white-space: normal;
              word-break: break-word;
            }
            .icon1{
              width: 8.589vw;
              height: 6.002vw;
            }
            .icon2{
              width: 6.872vw;
              height: 6.927vw;
            }
            .icon3{
              height: 7.425vw;
              width: 6.505vw;
            }
            .icon4{
              height: 6.338vw;
              width: 6.002vw;
            }
          }
          .DoneMask{
            width: 12.191vw;
            height: 14.922vw;
            border-radius: 0.833vw;
            position: absolute;
            left: 0;
            top: 0;
            background-color: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 5.5vw;
            .finished{
              width: 6.341vw;
              height: 5.119vw;
            }
          }
        }
        @keyframes blink {
          0% {
            //width: calc(100% + 3px);
            //height: calc(7.567vh + 3px);
            //transform: translate(-1.5px, -1.5px); /* 使用 transform 替代 position 和 top/left 等 */
            background: linear-gradient(92.61deg, #D10019 -13.54%, #FFFFFF 62.53%, #4E9B00 107.21%);
            //border-radius: calc(2.222vw + 1px);
          }
          50% {
            //width: calc(100% + 5px);
            //height: calc(7.567vh + 5px);
            //transform: translate(-2.5px, -2.5px); /* 同样使用 transform */
            background-color: rgba(255, 255, 255, 0.8);
            //border-radius: calc(2.222vw + 2px);
          }
          100% {
            //width: calc(100% + 6px);
            //height: calc(7.567vh + 6px);
            //transform: translate(-3px, -3px); /* 使用 transform */
            background-color: rgba(255, 255, 255, 0.5);
            //border-radius: calc(2.222vw + 3px);
          }
        }

        .available {
          height: 106%;
          width: 108%;
          position: absolute;
          border-radius: 0.833vw;
          top: -3%;
          left: -4%;
          animation: blink 550ms infinite;
          z-index: 0;
        }
      }
    }
    .checkInBtnBox{
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 3.055vw;

      .checkInBtn{
        height: 7.777vw;
        width: 69.616vw;
        background-color: #F1DAB0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        border-radius: 1.111vw;
        font-weight: 700;
      }
      .checkInBtnNo{
        height: 7.777vw;
        width: 69.616vw;
        background-color: #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #a4a4a4;
        border-radius: 1.111vw;
        font-weight: 700;
      }
    }
  }
  .taskDoneBox{
    width: 100%;
    padding: 0 3.697vw;
    .taskDoneCard{
      width: 100%;
      height: 69.716vw;
      background-color: rgba(45,45,45);
      border-radius: 1.666vw;
      box-shadow: inset 0 -40px 40px -40px rgba(0, 0, 0, 0.7);
      overflow: hidden;
      padding: 2vw;
      //padding-bottom: 11.11vw;
      display: flex;
      flex-direction: column;
      .title{
        font-size: 3.888vw;
        color: #ECECEC;
        font-weight: 700;
      }
      /* 滚动条轨道 */
      ::-webkit-scrollbar-track {
        background: #000000; /* 轨道背景颜色 */
      }

      /* 滚动条滑块 */
      ::-webkit-scrollbar-thumb {
        background: #B6B6B6; /* 滑块颜色 */
      }
      .contentList{
        overflow-x: hidden;
        overflow-y: scroll;
        margin-top: 2.722vw;
        //border: 1px solid red;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap:2vw;
        padding-right: 2vw;
        .taskItem{
          width: 100%;
          height: 12.5vw;
          background-color: #1C1C1C;
          border-radius: 1.388vw;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 2vw;
          .taskInfo{
            display: flex;
            align-items: center;
            gap: 2.563vw;
            .taskIcon{
              width: 10.022vw;
              height: 10.352vw;
              border-radius: 1.388vw;
              background-color: #F5F5F5;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .icon{
                width: 6.338vw;
                height: 6.388vw;
              }
              .label{
                font-size: 2.777vw;
                color: #BD6200;
                font-weight: 700;
              }
            }
            .label{
              font-size: 3.33vw;
              color: #fff;
              font-weight: 700;
              max-width: 38vw;
            }
          }
          .tasBtn{
            width: 21.047vw;
            height: 6.541vw;
            background-color: #F1DAB0;
           border-radius: 1.11vw;
            font-size: 2.777vw;
            font-weight: 700;
            color: #000;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .tasBtnGo{
            width: 21.047vw;
            height: 6.541vw;
            //background-color: #F1DAB0;
            border-radius: 1.11vw;
            font-size: 2.777vw;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #F1DAB0;
            color: #F1DAB0;
          }
          .tasBtnDone{
            width: 21.047vw;
            height: 6.541vw;
            //background-color: #F1DAB0;
            border-radius: 1.11vw;
            font-size: 2.777vw;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #878787;
            color: #878787;
          }
        }
      }
    }
  }

  .ruleMask {
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
    .ruleBox {
      height: 132.5vw;
      width: 87.614vw;
      background-color: rgb(20,20,20);
      border: 1px solid rgb(115,115,115);
      border-radius: 3.055vw;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 5vw;
      animation: openBox 0.3s ease-in-out;
      .closeRulePopBtn{
        position: absolute;
        top: -8vw;
        right: 0;
        height: 4.7vw;
        width: 4.7vw;
      }
      .title{
        font-family: 'Inter';
        font-style: normal;
        font-weight: 800;
        font-size: 6.111vw;
        line-height: 7.5vw;
        /* identical to box height */
        text-transform: capitalize;
        background: linear-gradient(180deg, #FFE281 0%, #FFF1B5 50%, #CEBF5E 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        padding: 5vw 0;
      }
      .content{
        height: 100%;
        width: 100%;
        padding: 0 5vw;
        color: #C3C3C3;
        font-size: 4.166vw;
        overflow-x: hidden;
        overflow-y: auto;
      }
    }
  }
  .confirmMask{
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
  .confirmBox{
    width: 81.558vw;
    height: 55.002vw;
    background-color: rgb(20,20,20);
    border: 1px solid rgb(115,115,115);
    border-radius: 3.055vw;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: openBox 0.3s ease-in-out;
    .title{
      color: #FFFFFF;
      font-size: 5.555vw;
      font-weight: 700;
      padding: 6vw 0;
    }
    .content{
      height: 18vw;
      //border: 1px solid red;
      color: #C4C4C4;
      font-size: 4.444vw;
      //padding-bottom: 10vw;
      margin-top: 3vw;
      padding: 0 7vw;
    }
    .checkTheVIPPrivileges{
      color: #0095FF;
      font-size: 3.888vw;
      border-bottom: 1px solid;
      width: 43vw;
      margin-top: 2vw;
    }
    .claimBtn{
      width: 68.858vw;
      height: 8.883vw;
      border-radius: 1.388vw;
      font-size: 4.166vw;
      color: #000;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(to right, #EFD6AD 0%, #DAB67C 100%);
      margin-top: 2vw;
    }
    //.closeRulePopBtn{
    //  position: absolute;
    //  top: -6vw;
    //  right: 0;
    //  height: 4.2vw;
    //  width: 4vw;
    //}
  }
}
}
.NewcomerSignIn{
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow: auto;
  /* 整个滚动条 */
  ::-webkit-scrollbar {
    width: 0.852vw; /* 设置滚动条宽度 */
    border-radius: 0px; /* 设置滚动条圆角 */
    margin-left: 2vw;
  }
  .bannerBox{
    width: 100%;
    height: 45.052vw;
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 15.555vw;
    .back{
      position: absolute;
      display: flex;
      align-items: center;
      height: 5.833vw;
      left: 7.127vw;
      top: 3.222vw;
      .backIcon{
        width: 3.688vw;
        height: 5.444vw;
      }
      .backText{
        margin-left: 3vw;
        color: #EBD2A1;
        font-size: 5vw;
        font-weight: 700;
        padding-top: 1vw;
      }
    }
    .banner{
      height: 100%;
      width: 100%;
    }
    .bannerTextBox{
      position: absolute;
      left: 5%;
      top: 40%;
      display: flex;
      flex-direction: column;
      gap: 0vw;
      .title{
        color: #FFFFFF;
        font-size: 4.5833vw;
        font-weight: 700;
      }
      .timeBox{
        display: flex;
        justify-content: center;
        flex-direction: column;
        //border: 1px solid red;
        .b{
          color: #FFF59D;
          font-weight: 700;
          font-size: 7.5vw;
          padding-left: 2.5vw;
          margin-top: -4vw;
        }
        .time{
          display: flex;
          align-items: center;
          margin-top: 1.5vw;
          .timeItem{
            display: flex;
            flex-direction: column;
            align-items: center;
            .value{
              color: #FFF59D;
              font-weight: 700;
              font-size: 7.5vw;

            }
            .label{
              color: #636363;
              font-weight: 700;
              font-size: 2.777vw;
            }
          }
        }
      }
    }
  }
  .checkInBox{
    display: flex;
    flex-direction: column;
    padding: 3.697vw;
    .row1{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 2.9vw;
      .checkInTitle{
        font-size: 4.444vw;
        color: #fff;
        font-weight: 700;
      }
      .ruleslabel{
        font-size: 3.277vw;
        color: #4897FF;
        text-decoration: underline;
        text-decoration-color: #4897FF;
        text-underline-offset: 4px;
      }
    }
    .row2{
      padding-bottom: 2.9vw;
      font-size: 3.055vw;
      color: #6F6F6F;
    }
    .row3{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 4.441vw;
      .checkInItemBox{
        position: relative;
        .checkInCardBox{
          width: 12.191vw;
          height: 14.922vw;
          background: #F5F5F5;
          box-shadow: inset 0px 0px 1.6px rgba(0, 0, 0, 0.8);
          border-radius: 0.833vw;
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 5.5vw;
          .items{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 1.2vw;
            .vipLabel{
              color: #007591;
              font-size: 2.8vw;
              font-weight: 700;
              text-align: center;
              white-space: normal;
              word-break: break-word;
            }
            .bonusLabel{
              width: 11vw;
              color: #BD6200;
              font-size: 2.8vw;
              font-weight: 700;
              text-align: center;
              white-space: normal;
              word-break: break-word;
            }
            .icon1{
              width: 8.589vw;
              height: 6.002vw;
            }
            .icon2{
              width: 6.872vw;
              height: 6.927vw;
            }
            .icon3{
              height: 7.425vw;
              width: 6.505vw;
            }
            .icon4{
              height: 6.338vw;
              width: 6.002vw;
            }
          }
          .DoneMask{
            width: 12.191vw;
            height: 14.922vw;
            border-radius: 0.833vw;
            position: absolute;
            left: 0;
            top: 0;
            background-color: rgba(0,0,0,0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 5.5vw;
            .finished{
              width: 6.341vw;
              height: 5.119vw;
            }
          }
        }
        @keyframes blink {
          0% {
            //width: calc(100% + 3px);
            //height: calc(7.567vh + 3px);
            //transform: translate(-1.5px, -1.5px); /* 使用 transform 替代 position 和 top/left 等 */
            background: linear-gradient(92.61deg, #D10019 -13.54%, #FFFFFF 62.53%, #4E9B00 107.21%);
            //border-radius: calc(2.222vw + 1px);
          }
          50% {
            //width: calc(100% + 5px);
            //height: calc(7.567vh + 5px);
            //transform: translate(-2.5px, -2.5px); /* 同样使用 transform */
            background-color: rgba(255, 255, 255, 0.8);
            //border-radius: calc(2.222vw + 2px);
          }
          100% {
            //width: calc(100% + 6px);
            //height: calc(7.567vh + 6px);
            //transform: translate(-3px, -3px); /* 使用 transform */
            background-color: rgba(255, 255, 255, 0.5);
            //border-radius: calc(2.222vw + 3px);
          }
        }

        .available {
          height: 106%;
          width: 108%;
          position: absolute;
          border-radius: 0.833vw;
          top: -3%;
          left: -4%;
          animation: blink 550ms infinite;
          z-index: 0;
        }
      }
    }
    .checkInBtnBox{
      display: flex;
      align-items: center;
      justify-content: center;
      //padding-bottom: 3.055vw;
      .checkInBtn{
        height: 8.611vw;
        width: 69.616vw;
        background-color: #F1DAB0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        border-radius: 1.111vw;
        font-weight: 700;
      }
      .checkInBtnNo{
        height: 8.611vw;
        width: 69.616vw;
        background-color: #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #a4a4a4;
        border-radius: 1.111vw;
        font-weight: 700;
      }
    }
  }
  .taskDoneBox{
    width: 100%;
    padding: 0 3.697vw;
    margin-bottom: 5vw;
    .taskDoneCard{
      width: 100%;
      height: 100vw;
      background-color: rgba(45,45,45);
      border-radius: 1.666vw;
      box-shadow: inset 0 -40px 40px -40px rgba(0, 0, 0, 0.7);
      overflow: hidden;
      padding: 2vw;
      //padding-bottom: 11.11vw;
      display: flex;
      flex-direction: column;
      .title{
        font-size: 3.888vw;
        color: #ECECEC;
        font-weight: 700;
      }
      /* 滚动条轨道 */
      ::-webkit-scrollbar-track {
        background: #000000; /* 轨道背景颜色 */
      }

      /* 滚动条滑块 */
      ::-webkit-scrollbar-thumb {
        background: #B6B6B6; /* 滑块颜色 */
      }
      .contentList{
        overflow-x: hidden;
        overflow-y: scroll;
        margin-top: 2.722vw;
        //border: 1px solid red;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap:2vw;
        padding-right: 2vw;
        .taskItem{
          width: 100%;
          height: 12.5vw;
          background-color: #1C1C1C;
          border-radius: 1.388vw;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 2vw;
          .taskInfo{
            display: flex;
            align-items: center;
            gap: 2.563vw;
            .taskIcon{
              width: 10.022vw;
              height: 10.352vw;
              border-radius: 1.388vw;
              background-color: #F5F5F5;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .icon{
                width: 6.338vw;
                height: 6.388vw;
              }
              .label{
                font-size: 2.777vw;
                color: #BD6200;
                font-weight: 700;
              }
            }
            .label{
              font-size: 3.33vw;
              color: #fff;
              font-weight: 700;
              max-width: 38vw;
            }
          }
          .tasBtn{
            width: 21.047vw;
            height: 6.541vw;
            background-color: #F1DAB0;
            border-radius: 1.11vw;
            font-size: 2.777vw;
            font-weight: 700;
            color: #000;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .tasBtnGo{
            width: 21.047vw;
            height: 6.541vw;
            //background-color: #F1DAB0;
            border-radius: 1.11vw;
            font-size: 2.777vw;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #F1DAB0;
            color: #F1DAB0;
          }
          .tasBtnDone{
            width: 21.047vw;
            height: 6.541vw;
            //background-color: #F1DAB0;
            border-radius: 1.11vw;
            font-size: 2.777vw;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #878787;
            color: #878787;
          }
        }
      }
    }
  }

  .ruleMask {
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
    .ruleBox {
      height: 132.5vw;
      width: 87.614vw;
      background-color: rgb(20,20,20);
      border: 1px solid rgb(115,115,115);
      border-radius: 3.055vw;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 5vw;
      animation: openBox 0.3s ease-in-out;
      .closeRulePopBtn{
        position: absolute;
        top: -8vw;
        right: 0;
        height: 4.7vw;
        width: 4.7vw;
      }
      .title{
        font-family: 'Inter';
        font-style: normal;
        font-weight: 800;
        font-size: 6.111vw;
        line-height: 7.5vw;
        /* identical to box height */
        text-transform: capitalize;
        background: linear-gradient(180deg, #FFE281 0%, #FFF1B5 50%, #CEBF5E 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        padding: 5vw 0;
      }
      .content{
        height: 100%;
        width: 100%;
        padding: 0 5vw;
        color: #C3C3C3;
        font-size: 4.166vw;
        overflow-x: hidden;
        overflow-y: auto;
      }
    }
  }
  .confirmMask{
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
    .confirmBox{
      width: 81.558vw;
      height: 55.002vw;
      background-color: rgb(20,20,20);
      border: 1px solid rgb(115,115,115);
      border-radius: 3.055vw;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      animation: openBox 0.3s ease-in-out;
      .title{
        color: #FFFFFF;
        font-size: 5.555vw;
        font-weight: 700;
        padding: 6vw 0;
      }
      .content{
        height: 18vw;
        //border: 1px solid red;
        color: #C4C4C4;
        font-size: 4.444vw;
        //padding-bottom: 10vw;
        margin-top: 3vw;
        padding: 0 7vw;
      }
      .checkTheVIPPrivileges{
        color: #0095FF;
        font-size: 3.888vw;
        border-bottom: 1px solid;
        width: 43vw;
        margin-top: 2vw;
      }
      .claimBtn{
        width: 68.858vw;
        height: 8.883vw;
        border-radius: 1.388vw;
        font-size: 4.166vw;
        color: #000;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(to right, #EFD6AD 0%, #DAB67C 100%);
      }
      //.closeRulePopBtn{
      //  position: absolute;
      //  top: -6vw;
      //  right: 0;
      //  height: 4.2vw;
      //  width: 4vw;
      //}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewcomerSignIn/index.vue